/*
  Fills in the flag emoji next to the country selector's trigger button
  and each row in the country list -- see snippets/country-localization.liquid
  (the `.loc-flag` placeholder spans) and assets/component-localization-form.css.

  Flags are derived from the ISO 3166-1 alpha-2 country code (which
  Shopify already gives us per-country/per-market) using the standard
  regional-indicator-symbol trick, rather than a hardcoded per-country
  image/emoji table -- works for every country Shopify supports, with
  no maintenance as markets are added or removed.
*/
(function () {
  function isoToFlagEmoji(iso) {
    if (!iso || iso.length !== 2) return '';
    return iso.toUpperCase().replace(/./g, function (c) {
      return String.fromCodePoint(c.charCodeAt(0) + 127397);
    });
  }

  function fillFlags(root) {
    (root || document).querySelectorAll('.loc-flag').forEach(function (el) {
      if (el.textContent) return; // already filled
      var iso = el.getAttribute('data-country-iso');
      if (!iso) {
        var link = el.closest('[data-value]');
        if (link) iso = link.getAttribute('data-value');
      }
      if (iso && iso.length === 2) {
        el.textContent = isoToFlagEmoji(iso);
      }
    });
  }

  fillFlags(document);

  // The theme editor can swap header/footer section markup back in
  // without a full page reload -- re-fill any new flag placeholders.
  document.addEventListener('shopify:section:load', function (event) {
    fillFlags(event.target || document);
  });
})();
